export { default } from './BestMatchBadge'
